<template lang="html">
  <div class="centerx">
    <vs-popup 
      fullscreen
      title="Pré-visualização da Notícia"
      :active.sync="isPreviewPopupActive"
      class="news-preview-popup"
    >
      <div class="device-buttons-wp">
        <vs-button 
          color="primary"
          @click="selectedDevice = 'desktop'"
          type="flat" 
          icon="laptop_windows"
          size="small"
          class="mr-3 device-button"
        >
          Computador
        </vs-button>

        <vs-button 
          color="primary"
          @click="selectedDevice = 'mobile'"
          type="flat" 
          icon="stay_current_portrait"
          size="small"
          class="device-button"
        >
          Celular
        </vs-button>
      </div>

      <div class="mt-5">
        <vs-row>
          <vs-col id="preview-content" :vs-w="selectedDevice === 'desktop' ? 8 : 3">
            <div>
              <img :src="images.header[selectedDevice]" width="100%" />
            </div>

            <div class="news-content">
              <h1
                :class="{
                  'headline-desktop': (selectedDevice === 'desktop'),
                  'headline-mobile': (selectedDevice === 'mobile'),
                }"
              >
                {{newsData.headline}}
              </h1>

              <h2 class="subtitle">{{newsData.subtitle}}</h2>

              <div
                :class="{
                  'author-info-desktop': (selectedDevice === 'desktop'),
                  'author-info-mobile': (selectedDevice === 'mobile'),
                }"
              >
                <div class="author-name-avatar-wp">
                  <vs-avatar size="50px" />

                  <div class="ml-5">
                    <p class="author-name">Por {{authorName}}</p>
                    <p>{{datetime}}</p>
                  </div>
                </div>

                <img
                  :class="{'scale-img': (selectedDevice === 'mobile')}"
                  :src="images.socials"
                />
              </div>

              <div class="news-text" v-html="newsData.content" />

              <div class="hidden-content mt-5" v-if="newsData.hidden_content !== ''">
                <button class="show-more-button" v-if="!readMore" @click="readMore = true">
                  <span>LER MAIS</span>
                  <feather-icon
                    icon="ChevronDownIcon"
                    svgClasses="w-5 h-5 text-grey-dark stroke-current ml-1"
                  />
                </button>
                <div :class="`news-text ${!readMore ? 'is-hidden' : ''}`" v-html="newsData.hidden_content" />
              </div>
            </div>

            <div>
              <img
                :src="images.newsletter[selectedDevice]"
                width="100%"
              />
            </div>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { formatDate } from '@/utils'

export default {
  name: 'news-preview-popup',
  props: {
    isPreviewPopupActive: {
      type: Boolean,
      default: false
    },
    newsData: Object
  },
  data() {
    return {
      readMore: false,
      authorName: '',
      selectedDevice: 'desktop',
      images: {
        header: {
          desktop: 'https://clean-code.s3.amazonaws.com/jornaldamanha/images/1589303892PwiC2oW8sd.png',
          mobile: 'https://clean-code.s3.amazonaws.com/jornaldamanha/images/1589309904SCwUdmUKlN.png'
        },
        newsletter: {
          desktop: 'https://clean-code.s3.amazonaws.com/jornaldamanha/images/1610978316hIYgKUnwUR.png',
          mobile: 'https://clean-code.s3.amazonaws.com/jornaldamanha/images/1589309871QqMR9CSwN0.png'
        },
        socials: 'https://clean-code.s3.amazonaws.com/jornaldamanha/images/1589304891pFjZpVviHF.png'
      }
    }
  },
  computed: {
    datetime() {
      const { date_only, hour, minute } = formatDate(new Date)
      return `${date_only} - ${hour}:${minute}`
    }
  },
  watch: {
    isPreviewPopupActive: function (val) {
      if (!val) {
        this.$emit("closePreviewPopup")
      }
    }
  },
  mounted() {
    this.authorName = this.$store.state.AppActiveUser.name
  }
}
</script>

<style>
#preview-content {
  margin: 0 auto !important;
}

.hidden-content > .is-hidden {
  filter: blur(5px);
  height: 200px;
  overflow: hidden;
}

.show-more-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  font-size: 0.8rem;
  border: none;
  padding-left: 1.25em;
  padding-right: 1.25em;
  border-radius: 290486px;
  cursor: pointer;
  background-color: #f5f5f5;
  border-color: transparent;
  padding: calc(.5em - 1px) 1em;
  color: rgba(0,0,0,.7);
}

.show-more-button:hover {
  background-color: #EEEEEE;
}

.device-buttons-wp {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.device-button {
  font-size: 1em !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.news-content {
  width: 100%;
  margin: 20px auto;
}

.headline-desktop {
  font-family: 'Lato', sans-serif;
  font-size: 50px;
}

.headline-mobile {
  font-family: 'Lato', sans-serif;
  font-size: 27dp;
}

.subtitle,
.author-name {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 18px;
  margin: 20px 0;
}

.author-name { margin: 0; font-weight: 400; }

.author-info-desktop {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.author-info-desktop > .author-name-avatar-wp {
  display: flex;
  align-items: center;
}

.author-info-mobile {
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.author-info-mobile > .author-name-avatar-wp {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.news-text {
  font-family: 'Roboto', sans-serif;
  font-size: 18dp;
  width: 100%;
}

.news-text img {
  width: 100% !important;
}

.scale-img {
  transform: scale(0.85);
}
</style>